import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { BotPhaseView } from "./BotPhaseView";
import { BotPhaseViewStore } from "../../store/BotPhaseViewStore";
import { useStore } from "../../../../hooks";

export const BotPhaseViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/botPhase/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new BotPhaseViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <BotPhaseView botPhaseViewStore={store} />
      </PageLayout>
    </div>
  );
});
